import {getChampionships} from '@monpetitgazon/mpg-team-data';
import classNames from 'classnames';
import {keyBy} from 'lodash';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {championshipsRefs} from '../../../../../../components/ChampionshipSelector';
import Filters from '../../../../../../components/Filters';
import FilterGamesWeek from '../../../../../../components/Filters/GamesWeek';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterSeason from '../../../../../../components/Filters/Season';
import Loader from '../../../../../../components/Loader';
import {getChampionshipClubs} from '../../../../../Tools/Tds/Widgets/TdsList';
import {fetchMPMMatchesBadges} from '../../../../../../actions/entities/statistics/mpmBadges';
import {champIds} from '../../../../../../helpers/championship';
import './index.css';

class MPMBadgesWidget extends React.Component {
  constructor(props) {
    super(props);

    const month = moment().month();
    const year = moment().year();
    // Si on est en août ou plus la saison est l'année en cours.
    // Année en cours = 2018
    // Si mois < août Alors saison = 2017 Sinon saison = 2018
    const season = month >= 6 ? year : year - 1;

    let championships = {};
    getChampionships().forEach(
      value =>
        (championships[
          value.ref === 'en' ? 'GB-ENG' : value.ref.toUpperCase()
        ] = value.id),
    );

    this.state = {
      filters: {championship: 'FR', season, gamesWeeks: []},
      order: {key: 'key', value: 'asc'},
      isFetching: false,
      matchDays: {},
      highlightRefreshBtn: false,
      championships,
      clubs: undefined,
    };
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      switch (key) {
        case 'key':
          newOrder.value = 'asc';
          break;
        case 'value':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  onError = error => {
    this.setState({isFetching: false});
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong !<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  fetchMatchesBadges() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: response => {
        this.setState({isFetching: false, matchDays: response.rounds});
      },
    };

    if (!this.state.isFetching) {
      const {season, championship} = this.state.filters;
      const competitionId = champIds[championship];
      const payload = {competitionYear: season, competitionId};
      this.props.dispatch(fetchMPMMatchesBadges(payload, callBacks));
    }
  }

  static getSeasonOptions() {
    const year = moment().year();
    const season = moment().month() >= 7 ? year : year - 1;

    const seasonOptions = [];
    for (let i = parseInt(season, 10); i >= 2017; i--) {
      seasonOptions.push({value: i.toString(), text: `${i} - ${i + 1}`});
    }

    return seasonOptions;
  }

  getGamesWeekOptions() {
    const {matchDays} = this.state;
    if (matchDays) {
      const days = Object.keys(matchDays);
      return days.map(day => ({value: day, text: `Day ${day}`}));
    }
  }

  static getPercent(nb, total) {
    const percent = (parseInt(nb, 10) / total) * 100;
    return parseInt(numeral(percent > 100 ? 100 : percent).format('0,0'), 10);
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  getBadges() {
    const {filters, matchDays} = this.state;

    if (Object.keys(matchDays || []).length === 0) return null;

    const date = parseInt(filters.gamesWeeks, 10) || undefined;
    if (date) {
      const data = matchDays[date].badges;
      return Object.keys(data).map(key => ({key, value: data[key]}));
    } else {
      const values = Object.values(matchDays);
      const array = values.reduce((acc, curr) => {
        const values = Object.keys(curr.badges).map(key => ({
          key,
          value: curr.badges[key],
        }));
        if (!isEmpty(values)) {
          acc.push(...values);
        }
        return acc;
      }, []);

      const grouped = Array.from(
        array.reduce(
          (m, {key, value}) => m.set(key, (m.get(key) || 0) + value),
          new Map(),
        ),
        ([key, value]) => ({key, value}),
      );
      return grouped;
    }
  }

  componentDidMount() {
    this.fetchMatchesBadges();
    this.props.dispatch(
      getChampionshipClubs({
        onSuccess: response => this.setState({clubs: response}),
      }),
    );
  }

  renderTable() {
    const {order, matchDays} = this.state;
    const cols = {
      key: 'Name',
      value: 'Total',
    };

    const badges = this.getBadges();
    return !matchDays ? (
      <p className="text-center px-3 pb-3">No data to show</p>
    ) : (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>{this.renderThs(cols)}</tr>
          </thead>
          <tbody>
            {orderBy(badges, [order.key], [order.value]).map(badge => {
              return (
                <tr key={badge.key}>
                  <td>
                    <strong>{badge.key}</strong>
                  </td>
                  <td>{numeral(badge.value).format('0,0')}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderThs(cols, hideSort = false) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key && !hideSort,
          })}>
          {value}
          <span className={classNames('ml-1', {hidden: hideSort})}>
            <i
              className={classNames('fa', {
                'fa-sort': order.key !== key,
                [`fa-sort-${order.value}`]: order.key === key,
              })}
            />
          </span>
        </span>
      </th>
    ));
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const availableButtons = [
      'ALL',
      ...getChampionships().map(value =>
        championshipsRefs[value.ref].toUpperCase(),
      ),
    ];

    return (
      <div id="stats-players-goals-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-tags" />
              {` Badges`}
            </h3>
          </div>
          <div className="box-body">
            <Filters>
              <FilterLocation
                label="Championship:"
                availableButtons={availableButtons}
                onChange={championship => {
                  this.updateFilters({championship});
                  this.notifyRefresh(true);
                }}
                initialValue={this.state.filters.championship}
              />
              <FilterSeason
                label="Season:"
                onChange={season => {
                  this.updateFilters({season: parseInt(season, 10)});
                  this.notifyRefresh(true);
                }}
                options={MPMBadgesWidget.getSeasonOptions()}
                initialValue={this.state.filters.season}
              />
              <FilterGamesWeek
                label="Match days:"
                onChange={gamesWeeks => this.updateFilters({gamesWeeks})}
                options={this.getGamesWeekOptions()}
                selectProps={{multiple: true}}
              />
              <button
                onClick={this.fetchMatchesBadges.bind(this)}
                className={classNames('btn btn-submit', {
                  'btn-default': !highlightRefreshBtn,
                  'btn-success': highlightRefreshBtn,
                })}>
                <i
                  className={classNames('fa fa-refresh', {
                    'fa-spin': isFetching,
                  })}
                />
              </button>
            </Filters>
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    data: state.app.statistics.players.goals,
    players: keyBy(state.app.players?.response?.players, 'id'),
  }),
  dispatch => ({dispatch}),
)(MPMBadgesWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Badges/Widgets/Badges/index.js